<img [ngClass]="{'img-thumbnail-small': imgtype == 'square','img-long': imgtype == 'rect'} " 
src="{{orgimage.orgimageurl}}" 
(error)="refreshUrl()"/>
